export const getDriverInitials = (name: string) => {
    return name
        .split(' ')
        .map((each) => each.substring(1, 0))
        .join('')
        .toUpperCase();
};
